import React, { useState, useEffect, useContext } from "react";
import PopoverInput from "./inner/popoverInput.jsx";
import { DataSourceContext, IsMobileContext } from "../context/contexts.jsx";


const DetailedSelectItem = ({ destination, onSelect }) => {
    return (
        <div className={"text-content_2 hover:bg-content_5 rounded-[8px] mr-2 h-20  form-checkbox-text-left  "} onClick={() => onSelect(destination)}>
            <div className="w-25 p-1">
                {destination.image &&
                    <img className="rounded-[8px]" src={destination.image} />
                } 
            </div>
            <div className="flex flex-col h-1/1 justify-around">
                <div className="text-tiny text-content_3">{destination.ancestors?.join(" > ")}</div>
                <div className="text-lg">{destination.name}</div>
            </div>
        </div>);
}

const SimpleSelectItem = ({ destination, onSelect, type }) => {
    return (
        <div className={"text-content_2 hover:bg-content_5 rounded-[8px] mr-2  form-checkbox-text-left " + (type == "region" ? " pl-8" : "")} onClick={() => onSelect(destination)}>
            {destination.name}
        </div>)
}

const DestinationPicker = ({ departureAirports, selectedDestination, accomIsLocked, onUpdate }) => {
    const [flatDestinations, setFlatDestinations] = useState(null);
    const [filteredDestinations, setFilteredDestinations] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [filterText, setFilterText] = useState("");
    const dataSource = useContext(DataSourceContext);
    const isMobile = useContext(IsMobileContext);
    const needsDep = dataSource.requiresDeparture !== false;
    useEffect(() => {
        async function fetchData() {
            setFlatDestinations(null);
            if (!needsDep || departureAirports.length > 0) {
                var destinations = await dataSource.getDestinations(departureAirports);
                setFlatDestinations(destinations);
                if (selectedDestination && !accomIsLocked) {
                    var isFound = false;
                    for (let index = 0; index < destinations.countries.length; index++) {
                        const country = destinations.countries[index];
                        if (country.code == selectedDestination.code) {
                            isFound = true;
                            break;
                        }
                        for (let rIndex = 0; rIndex < country.regions.length; rIndex++) {
                            const element = country.regions[rIndex];
                            if (element.code == selectedDestination.code) {
                                isFound = true;
                                break;
                            }
                        }
                    }
                    if(!isFound){
                        onUpdate(null);
                    }
                }
            }}
            fetchData();
        }, [departureAirports,dataSource]);

    useEffect(() => {
        async function fetchData() {
            setFilteredDestinations(null);
            var destinations = await dataSource.getDestinationsWithTextSearch(departureAirports, filterText);
            setFilteredDestinations(destinations);
        }
        if (filterText && filterText != "") {
            fetchData();
        } else {
            setFilteredDestinations(null);
        }
    }, [filterText]);

    const onSelect = (selected) => {
        setFilterText("");
        setFilteredDestinations(null);
        setIsOpen(false);
        onUpdate({ name: selected.name, code: selected.code });
    }

    let inputText = "Destination or Hotel";
    if (selectedDestination) {
        inputText = selectedDestination.name;
    }

    let entries = [];
    if (filteredDestinations) {
        for (let index = 0; index < filteredDestinations.destinations.length; index++) {
            const country = filteredDestinations.destinations[index];
            entries.push(<DetailedSelectItem destination={country} key={index} onSelect={onSelect} />);
        }
    } else {
        if (flatDestinations) {
            for (let index = 0; index < flatDestinations.countries.length; index++) {
                const country = flatDestinations.countries[index];
                entries.push(<SimpleSelectItem destination={country} key={index} onSelect={onSelect} type="country" />);
                for (let rIndex = 0; rIndex < country.regions.length; rIndex++) {
                    const element = country.regions[rIndex];
                    entries.push(<SimpleSelectItem destination={element} key={index + "_" + rIndex} onSelect={onSelect} type="region" />)
                }
            }
        }
    }
    let header = null;
    if (isMobile) {
        header = <div className="relative">
            <input type="text" value={filterText} onChange={(e) => setFilterText(e.target.value)} className="form-input" placeholder={"Search"} />
             
        </div>;
    }
    return <PopoverInput header={header} disabled={(needsDep && departureAirports.length == 0) || accomIsLocked} inputText={inputText} isLoading={flatDestinations == null} onTextUpdate={setFilterText} filterText={filterText} isOpen={isOpen} setIsOpen={setIsOpen}>
        <div className="">
            {entries}
        </div>
    </PopoverInput>
}
export default DestinationPicker;
